"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stream_chat_react_1 = require("stream-chat-react");
const UserIcon_1 = require("./UserIcon");
const ActionThread_1 = __importDefault(require("../../assets/icons/ActionThread"));
const data_1 = require("../../assets/data");
const MessageTimestampController_1 = require("../../context/MessageTimestampController");
const EyeSlash_1 = __importDefault(require("../../assets/icons/EyeSlash"));
const DashCircle_1 = __importDefault(require("../../assets/icons/DashCircle"));
const CheckCircleFill_1 = __importDefault(require("../../assets/icons/CheckCircleFill"));
const useCustomCommands_1 = require("../../hooks/useCustomCommands");
const TimeoutIcon_1 = __importDefault(require("../../assets/icons/TimeoutIcon"));
const ChatPinnedMessage_1 = require("./ChatPinnedMessage");
const PinIcon_1 = __importDefault(require("../../assets/icons/PinIcon"));
const getTimeStamp = (messageCreatedAt) => {
    if (!messageCreatedAt)
        return '';
    const createdAt = new Date(messageCreatedAt);
    let lastHours = createdAt.getHours();
    let lastMinutes = createdAt.getMinutes();
    let half = 'AM';
    if (lastHours === undefined || lastMinutes === undefined) {
        return '';
    }
    if (lastHours > 12) {
        lastHours = lastHours - 12;
        half = 'PM';
    }
    if (lastHours === 0)
        lastHours = 12;
    if (lastHours === 12)
        half = 'PM';
    if (lastMinutes.toString().length === 1) {
        lastMinutes = `0${lastMinutes}`;
    }
    return `${lastHours}:${lastMinutes} ${half}`;
};
const getReplyButtonText = (reply_count) => {
    if (!reply_count)
        return '';
    if (reply_count === 1)
        return '1 reply';
    return `${reply_count} Replies`;
};
const MessageActions = ({ onOpenThread, message, client, info }) => {
    const banUser = async (timeout = 0) => {
        if (!message.user) {
            return;
        }
        if (!client.user) {
            return;
        }
        const FOURTY_EIGHT_HOURS_IN_MINUTES = 2880;
        const data = {
            userToBan: message.user.id,
            timeout: timeout != 0 ? timeout : FOURTY_EIGHT_HOURS_IN_MINUTES,
            reason: "banned for 30 minutes",
            banned_by_id: client.user.id,
            channelId: info.channelId,
        };
        const response = await fetch("/stream/ban-user", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(data),
        });
    };
    const unbanUser = async () => {
        if (!message.user) {
            return;
        }
        if (!client.user) {
            return;
        }
        const response = await fetch("/stream/unban-user", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                userToUnban: message.user.id,
                channelId: info.channelId,
            }),
        });
    };
    const handleDeleteMessage = (0, stream_chat_react_1.useDeleteHandler)(message);
    const pinMessage = async () => {
        console.log('here');
        await client.pinMessage(message, null);
    };
    if (!client.user) {
        return null;
    }
    if (!message.user) {
        return null;
    }
    if (message.pinned) {
        return null;
    }
    if (client.user.id === "anonymous") {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-message__actions-wrapper", children: [!!(client.user.role == "moderator") && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", { style: { cursor: "pointer" }, onClick: (_) => pinMessage(), title: "Pin message", children: (0, jsx_runtime_1.jsx)(PinIcon_1.default, {}) }), (0, jsx_runtime_1.jsx)("a", { style: { cursor: "pointer" }, onClick: handleDeleteMessage, title: "Delete message", children: (0, jsx_runtime_1.jsx)(EyeSlash_1.default, {}) }), (0, jsx_runtime_1.jsx)("a", { style: { cursor: "pointer" }, onClick: (_) => banUser(10), title: "Timeout user", children: (0, jsx_runtime_1.jsx)(TimeoutIcon_1.default, {}) }), !!message.user.banned ? ((0, jsx_runtime_1.jsx)("a", { style: { cursor: "pointer" }, onClick: unbanUser, title: "Unban user", children: (0, jsx_runtime_1.jsx)(CheckCircleFill_1.default, {}) })) : ((0, jsx_runtime_1.jsx)("a", { style: { cursor: "pointer" }, onClick: (_) => banUser(), title: "Ban user", children: (0, jsx_runtime_1.jsx)(DashCircle_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)("button", { onClick: onOpenThread, children: (0, jsx_runtime_1.jsx)(ActionThread_1.default, {}) })] }));
};
const ReactionList = ({ onOpenThread }) => {
    const { message } = (0, stream_chat_react_1.useMessageContext)();
    return ((0, jsx_runtime_1.jsx)("div", { className: 'custom-message__reaction-list', children: !!message.reply_count && ((0, jsx_runtime_1.jsx)("p", { onClick: onOpenThread, className: 'custom-message__reply-count', children: getReplyButtonText(message.reply_count) })) }));
};
const MessageContent = ({ color, message, handleAction, timestampEnabled, client, info }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    (0, react_1.useEffect)(() => {
        if (!info.bannedUsers.bans || !message.user) {
            return;
        }
        for (let i = 0; i < info.bannedUsers.bans.length; i++) {
            if (info.bannedUsers.bans[i].user.id != message.user.id) {
                continue;
            }
            message.user.banned = true;
        }
    }, []);
    if (typeof client.user == "undefined" ||
        typeof client.user.role == "undefined") {
        return null;
    }
    if (!message.user) {
        return null;
    }
    client.on("user.banned", (event) => {
        if (!message.user || !event.user) {
            return;
        }
        const userIsBanned = message.user.id == event.user.id;
        if (!userIsBanned) {
            return;
        }
        message.user.banned = true;
    });
    client.on("user.unbanned", (event) => {
        if (!message.user || !event.user) {
            return;
        }
        const userIsUnbanned = message.user.id == event.user.id;
        if (!userIsUnbanned) {
            return;
        }
        message.user.banned = false;
    });
    if (message.user.banned && client.user.id == message.user.id) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-message__content", children: [(0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { type: (_a = message.user) === null || _a === void 0 ? void 0 : _a.role }), timestampEnabled && ((0, jsx_runtime_1.jsx)("span", { className: "timestamp", children: getTimeStamp(message.created_at) })), (0, jsx_runtime_1.jsx)("p", { className: "message-owner", style: { color }, children: ((_b = message.user) === null || _b === void 0 ? void 0 : _b.name) || ((_c = message.user) === null || _c === void 0 ? void 0 : _c.id) || "Unknown" }), (0, jsx_runtime_1.jsx)("p", { className: "message", children: "You have been banned from chat for 30 minutes." })] }));
    }
    if (message.type == "deleted") {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-message__content", children: [(0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { type: (_d = message.user) === null || _d === void 0 ? void 0 : _d.role }), timestampEnabled && ((0, jsx_runtime_1.jsx)("span", { className: "timestamp", children: getTimeStamp(message.created_at) })), (0, jsx_runtime_1.jsx)("p", { className: "message-owner", style: { color }, children: ((_e = message.user) === null || _e === void 0 ? void 0 : _e.name) || ((_f = message.user) === null || _f === void 0 ? void 0 : _f.id) || "Unknown" }), (0, jsx_runtime_1.jsx)("p", { className: "message", children: "deleted by moderator." })] }));
    }
    let newAttachments = new Array;
    let showLink = false;
    let textLink = "";
    let hrefLink = "";
    //if (message.attachments && message.attachments.length) {
    //    message.attachments.forEach((attachment) => {
    //        if (attachment.title_link && attachment.og_scrape_url) {
    //            showLink = true;
    //            textLink = attachment.og_scrape_url; //αυτό που έχει γράψει ο χρήστης
    //            hrefLink = attachment.og_scrape_url.startsWith("https://")
    //                ? attachment.og_scrape_url
    //                : "https://" + attachment.og_scrape_url; //το σωστό href με https
    //            if (attachment.type === "image") return; //αν είναι site url να μην το δείξει στο preview
    //        }
    //        newAttachments.push(attachment);
    //    });
    //}
    if (message.text) {
        const httpRegexG = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/g;
        let urlArray = message.text.match(httpRegexG);
        if (urlArray && urlArray[0]) {
            showLink = true;
            textLink = urlArray[0];
            hrefLink = urlArray[0];
        }
    }
    let messagePartOne;
    let messagePartTwo;
    let messagePartThree;
    let messageParts = new Array();
    if (showLink && message.text) {
        messageParts = message.text.split(textLink); //should always have length 2
    }
    if (messageParts.length == 2) {
        if (messageParts[0] === "") {
            messagePartOne = ((0, jsx_runtime_1.jsx)("a", { href: `${hrefLink}`, rel: "noopener noreferrer", target: "_blank", children: textLink }));
            if (messageParts[1] !== "") {
                messagePartTwo = messageParts[1];
                messagePartThree = "";
            }
        }
        else {
            messagePartOne = messageParts[0];
            messagePartTwo = ((0, jsx_runtime_1.jsx)("a", { href: `${hrefLink}`, rel: "noopener noreferrer", target: "_blank", children: textLink }));
            if (messageParts[1] !== "") {
                messagePartThree = messageParts[1];
            }
        }
    }
    else {
        messagePartOne = message.text;
        messagePartTwo = "";
        messagePartThree = "";
    }
    if (message.pinned) {
        return ((0, jsx_runtime_1.jsx)(ChatPinnedMessage_1.PinnedMessage, { message: message, messageTextList: { messagePartOne, messagePartTwo, messagePartThree }, info: info }));
    }
    //console.log("one: \n", messagePartOne, " two: ", messagePartTwo, " three: ", messagePartThree);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-message__content", children: [(0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { type: (_g = message.user) === null || _g === void 0 ? void 0 : _g.role }), timestampEnabled && ((0, jsx_runtime_1.jsx)("span", { className: "timestamp", children: getTimeStamp(message.created_at) })), (0, jsx_runtime_1.jsx)("p", { className: "message-owner", style: { color }, children: ((_h = message.user) === null || _h === void 0 ? void 0 : _h.name) || ((_j = message.user) === null || _j === void 0 ? void 0 : _j.id) || "Unknown" }), (0, jsx_runtime_1.jsxs)("p", { className: "message", children: [messagePartOne, messagePartTwo, messagePartThree] })] }), !!(newAttachments === null || newAttachments === void 0 ? void 0 : newAttachments.length) && ((0, jsx_runtime_1.jsx)(stream_chat_react_1.Attachment, { attachments: newAttachments, actionHandler: handleAction }))] }));
};
const GamingMessage = () => {
    const { openThread } = (0, stream_chat_react_1.useChannelActionContext)();
    const { handleAction, message } = (0, stream_chat_react_1.useMessageContext)();
    const { timestampEnabled } = (0, MessageTimestampController_1.useMessageTimestamp)();
    const commands = (0, useCustomCommands_1.useCustomCommands)();
    const { client } = (0, stream_chat_react_1.useChatContext)();
    const infoString = localStorage.getItem("info");
    if (!infoString) {
        return null;
    }
    const info = JSON.parse(infoString);
    const onOpenThread = (0, react_1.useCallback)((event) => {
        const chatPanel = document.querySelector('.str-chat__main-panel');
        if (chatPanel)
            chatPanel.style.display = 'none';
        openThread(message, event);
    }, [openThread, message]);
    const color = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        let selectedColor = ((_a = message.user) === null || _a === void 0 ? void 0 : _a.color) || '';
        if (((_b = message.user) === null || _b === void 0 ? void 0 : _b.role) == 'moderator') {
            selectedColor = '#FD960B';
        }
        else if (((_c = message.user) === null || _c === void 0 ? void 0 : _c.role) == 'guest') {
            selectedColor = '#0174DF';
        }
        else if (!selectedColor) {
            selectedColor = (0, data_1.getColor)();
        }
        return selectedColor;
    }, [message === null || message === void 0 ? void 0 : message.id]); // eslint-disable-line
    if (!commands) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-message__wrapper", children: [(0, jsx_runtime_1.jsx)(MessageContent, { color: color, message: message, handleAction: handleAction, timestampEnabled: timestampEnabled, client: client, info: info }), (0, jsx_runtime_1.jsx)(ReactionList, { onOpenThread: onOpenThread, reply_count: message.reply_count }), (0, jsx_runtime_1.jsx)(MessageActions, { onOpenThread: onOpenThread, client: client, info: info, message: message })] }));
};
exports.GamingMessage = GamingMessage;
